

































































import { Component, Vue } from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import floorApi from "@/api/floorApi";
import FloorPlan from "@/model/floor";
import {namespace} from "vuex-class";
import store from "@/store";
const routerStore = namespace("Router");
@Component({
  name: "FloorList",
  components: {
    QPaginate,
    QTableHeader,
  },
})
export default class FloorList extends Vue {
  @routerStore.Getter
  public getPreviousRouter;
  @routerStore.Getter
  public getSearchParameters;

  public headers = [
    { id: "id", name: "", order: "desc" },
    { id: "name", name: "名称", order: "" },
    { id: "total_property_used", name: "利用物件件数", order: "" },
    { id: "", name: "" },
  ];

  public search: any = {};

  public searchInital() {
    return {
      name: "",
    };
  }

  public pagination = new PaginateModel({
    page: 10,
    pageCount: 10,
    start: 10,
    end: 10,
    count: 10,
  });

  public floorPlans: FloorPlan[] = null;
  get getPaginate() {
    return this.pagination;
  }
  public async floorList(query) {
    const result = await floorApi.index(query);
    this.pagination = result.paginate;
    this.floorPlans = result.list;
  }

  mounted() {
    if( this.getPreviousRouter.matched[1] && this.getPreviousRouter.matched[1].name == "admin.floor-router"
      && this.getSearchParameters && this.getSearchParameters.floorList
    ) {
      this.search = this.getSearchParameters.floorList;
    } else {
      this.initalSearch(null);
    }

    this.floorList(this.search);
    // this.doSearch(this.search);
  }

  public clear() {
    this.search = this.searchInital();
    store.dispatch("Router/setSearchParameters", {floorList: null});
    this.changeState();
    this.doSearch(this.search);
  }

  public doSearch(query: any): void {
    this.floorList(query);
  }

  public onSearch(): void {
    store.dispatch("Router/setSearchParameters", {floorList: {...this.search}});
    this.changeState();
    this.doSearch(this.search);
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...this.search = this.searchInital(),
      ...query,
    };

    if (Object.keys(query).length > 0) {
      store.dispatch("Router/setSearchParameters", {floorList: this.search});
    } else {
      store.dispatch("Router/setSearchParameters", {floorList: null});
    }
  }
}
